import styled from '@emotion/styled';

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	flex: 1;
`;
export const ConferenceContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2.4rem;
	max-width: 92.2rem;
	width: 100%;
	margin: 0 auto;
	padding: 8rem 0rem;
	@media screen and (max-width: 1370px) {
		padding: 8rem 2rem;
	}
`;
export const ConferenceHeader = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1.6rem;
	width: 100%;
	.share_icon {
		display: flex;
		justify-content: flex-end;
	}
`;
export const ConferenceTitleBox = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.8rem;
	padding-bottom: 1.6rem;
	border-bottom: 1px solid #adb5bd;
`;
export const ConferenceTitle = styled.h2`
	font-size: ${(props) => props.theme.fontSize.sizeXl};
	font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	line-height: 130%;
	letter-spacing: -0.6px;
	color: #212529;
`;
export const ConferenceSubTitle = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 0.8rem;
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: 100%;
	letter-spacing: -0.6px;
	color: #868e96;
	white-space: nowrap;
`;
export const ImgBox = styled.div`
	width: 2.4rem;
	height: 2.4rem;
	cursor: pointer;
	img {
		width: 100%;
		height: 100%;
	}
`;
export const ContentBox = styled.div`
	display: flex;
	flex-direction: column;
	gap: 2.4rem;
`;
export const Content = styled.div`
	padding-bottom: 2.4rem;
	border-bottom: 1px solid #adb5bd;
	width: 100%;
	line-height: 160%;
	img {
		max-width: 100%;
		height: auto;
		display: block;
	}
`;
export const MenuBox = styled.div`
	display: flex;
	justify-content: space-between;
`;
export const MenuList = styled.div`
	display: flex;
	gap: 0.8rem;
	height: 4.4rem;
`;
export const Menu = styled.button`
	display: flex;
	align-items: center;
	gap: 0.2rem;
	height: 100%;
	padding: 0rem 1.2rem;
	border: 1px solid #212529;
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	line-height: 100%;
	letter-spacing: -0.6px;
	background-color: #fff;
	cursor: pointer;
`;
export const MenuActive = styled(Menu)`
	height: 100%;
	background-color: ${(props) => props.theme.colors.primary400};
	border: none;
	color: #fff;
`;
export const DownLoadBoxList = styled.div`
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(15rem, 19.2rem));
	gap: 0.8rem;
`;
export const DownLoadBox = styled.div`
	display: flex;
	gap: 1.2rem;
	align-items: center;
	width: 100%;
	padding: 1.2rem;
	background-color: #fff;
	border: 1px solid #dee2e6;
	width: fit-content;
	cursor: pointer;
`;
export const DownLoadContent = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1.2rem;
	max-width: 13.6rem;
	width: 100%;
	.title {
		font-size: 1.4rem;
		font-weight: 400;
		line-height: 100%;
		letter-spacing: -0.6px;
		color: #212529;
		width: 100%;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
	.sub_title {
		font-size: 1.2rem;
		font-weight: 400;
		line-height: 120%;
		letter-spacing: -0.6px;
		color: #868e96;
	}
`;
export const SocietyListContainer = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	flex: 1;
	/* gap: 4rem; */
	/* max-width: 135rem; */
	gap: 2rem;
	max-width: 84.4rem;
	width: 100%;
	margin: 0 auto;
	padding: 8rem 0;
	@media screen and (max-width: 900px) {
		padding: 8rem 2rem;
	}
`;
export const SocietyBoardBox = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 2rem;
	flex: 1;
`;
export const NoData = styled.p`
	color: #212529;
	font-size: 1.8rem;
	font-weight: 400;
	line-height: 100%;
	letter-spacing: -0.6px;
	white-space: nowrap;
`;

export const SocietyListTitle = styled.h2`
	font-size: ${(props) => props.theme.fontSize.sizeXl};
	font-weight: ${(props) => props.theme.fontWeight.weightSemi};
	line-height: 130%;
	letter-spacing: -0.6px;
	color: #212529;
`;
export const Table = styled.div`
	display: grid;
	grid-template-columns: 1fr auto auto;
	grid-auto-rows: minmax(40px, auto);
	.item1 {
		grid-row-start: 2;
		grid-row-end: 10;
	}
	.item2_1 {
		grid-row-start: 3;
		grid-row-end: 6;
	}
	.item2_3 {
		grid-row-start: 12;
		grid-row-end: 14;
	}
	.item2_4 {
		grid-row-start: 14;
		grid-row-end: 16;
	}
	.item3_1 {
		grid-row-start: 2;
		grid-row-end: 4;
	}
	.item3_2 {
		grid-row-start: 4;
		grid-row-end: 24;
	}
	.item3_3 {
		grid-row-start: 24;
		grid-row-end: 31;
	}
	.item3_4 {
		grid-row-start: 32;
		grid-row-end: 34;
	}
	.item3_5 {
		grid-row-start: 35;
		grid-row-end: 37;
	}
	.item3_6 {
		grid-row-start: 40;
		grid-row-end: 42;
	}
	.item3_7 {
		grid-row-start: 43;
		grid-row-end: 45;
	}
`;
export const TableHeadCell = styled.div`
	display: flex;
	align-items: center;
	background-color: #00377b;
	color: white;
	padding: 10px 15px;
	text-align: left;
	border-right: 2px solid white;
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-weight: ${(props) => props.theme.fontWeight.weightMedium};
	line-height: 150%;
	&.center {
		justify-content: center;
	}
`;
export const TableCell = styled.div`
	display: flex;
	align-items: center;
	background-color: #f1f3f5;
	padding: 10px 15px;
	border-right: 2px solid white;
	border-bottom: 2px solid white;
	font-size: ${(props) => props.theme.fontSize.sizeMd};
	font-weight: ${(props) => props.theme.fontWeight.weightRegular};
	line-height: 140%;
	letter-spacing: -0.6px;
	color: #212529;
	&.point {
		color: #12539e;
		font-weight: ${(props) => props.theme.fontWeight.weightBold};
	}
	&.center {
		justify-content: center;
	}
	&.min-height {
		min-height: 5.2rem;
	}
`;
export const PositionCell = styled(TableCell)`
	color: #00377b;
	font-weight: ${(props) => props.theme.fontWeight.weightMedium};
`;
